import gql from 'graphql-tag';

export default gql`
  mutation cancelTreatment($input: CancelTreatmentInput!) {
    cancelTreatment(input: $input) {
      success
    }
  }
`;
